import { IInputSlot, IScenarioObject, StarterQuestion } from "./agents.types";

/**
 * Helpers that centralize the string-vs-ScenarioObject discrimination for
 * `Agent.starter_questions`. Call sites (home cards, click handler, admin
 * editor) MUST read shape through these helpers rather than branching on
 * `typeof q` directly, so the union encoding lives in exactly one place.
 */

const isScenarioObject = (q: StarterQuestion): q is IScenarioObject =>
    typeof q !== "string";

/** Card text regardless of shape. */
export const getStarterQuestionText = (q: StarterQuestion): string =>
    isScenarioObject(q) ? q.question : q;

/** Document slots for a scenario; `[]` for a plain string. */
export const getStarterQuestionSlots = (q: StarterQuestion): IInputSlot[] =>
    isScenarioObject(q) ? q.input_slots : [];

/** Scenario-object form; a plain string becomes a no-slots scenario. */
export const asScenarioObject = (q: StarterQuestion): IScenarioObject =>
    isScenarioObject(q) ? q : { question: q, input_slots: [] };

/** Whether selecting this scenario should gate on documents first. */
export const hasInputSlots = (q: StarterQuestion): boolean =>
    getStarterQuestionSlots(q).length > 0;

/** Total documents a scenario requires: sum of `min_count` over required slots. */
export const requiredDocCount = (q: StarterQuestion): number =>
    getStarterQuestionSlots(q)
        .filter((s) => s.required)
        .reduce((total, s) => total + s.min_count, 0);
